// @ts-nocheck


import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import notification from 'antd/lib/notification';














export const notificationLoading = (config) => {
  notification.open({
    duration: 0,
    ...config,
    icon: <LoadingOutlined style={{ color: '#286EF6' }} />
  });
};
